import { ILojaConfig, IMelhorEnvioConfig } from "interfaces/loja";
import api from "./api";
import { IMelhorEnvioServico } from "interfaces/loja/freteMelhorEnvio";

/**
 * API: Listar as configurações da loja
 */
export async function getLojaConfig(): Promise<{
  data: ILojaConfig;
  status: number;
}> {
  try {
    const { data, status } = await api.get("/loja/config/empresa");
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

/**
 * API: Atualizar as configurações da loja
 */
export async function createOrUpdateLojaConfig(data: any) {
  try {
    const { data: responseData, status } = await api.post(
      "/loja/config/empresa",
      data
    );
    return { data: responseData, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

/**
 * API: Listar as configurações do Melhor Envio
 */
export async function getMelhorEnvioConfig(): Promise<{
  data: IMelhorEnvioConfig | null;
  status: number;
}> {
  try {
    const { data, status } = await api.get("/loja/config/melhor-envio");
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

/**
 * API: Criar/Atualizar as configurações do Melhor Envio
 */
export async function createOrUpdateMelhorEnvioConfig(
  data: IMelhorEnvioConfig
) {
  try {
    const { data: responseData, status } = await api.post(
      "/loja/config/melhor-envio",
      data
    );
    return { data: responseData, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

/**
 * API: Remover as configurações do Melhor Envio
 */
export async function deleteMelhorEnvioConfig() {
  try {
    const { data, status } = await api.delete("/loja/config/melhor-envio");
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

/**
 * API: Listar os serviços do Melhor Envio
 */
/**
 * Inicia OAuth2 Melhor Envio (produção ou sandbox): retorna URL para redirect no browser.
 */
export async function getMelhorEnvioOAuthStartUrl() {
  return api.get<{ url: string }>("/melhor-envio/auth");
}

export async function getMelhorEnvioServicos(): Promise<{
  data: IMelhorEnvioServico[];
  status: number;
}> {
  try {
    const { data, status } = await api.get("/loja/frete/servicos");
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}
